<div class="snackbar-container">
  <span matSnackBarLabel> {{ data }} </span>
  <span matSnackBarActions>
    <button mat-button matSnackBarAction (click)="snackBarRef.dismissWithAction()">
      <!-- <tabler-icon name="x" size="icon-18" color="black"></tabler-icon> -->
    </button>
  </span>
</div>
